import { useQuery, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { TApiSavedReport, TApiSavedReportKind, TApiSavedReportsFilters, TApiSavedReportVisibility } from "../saved-reports-types"
import { removeUndefinedValues } from "../../utils/remove-values"

interface Props {
  filters: TApiSavedReportsFilters
}

export function useSavedReportsQuery(props: Props) {
  const {
    filters
  } = props

  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const query = useQuery(
    ['saved-reports', filters],
    async () => {
      const response = await apiClient.get('/saved_reports', {
        filters: removeUndefinedValues(filters),
      })

      if (!response.ok) {
        throw response.errors
      }

      return response as {
        savedReports: TApiSavedReport[]
      }
    },
    {
      onSuccess: (data) => {
        // Fill cache for individual saved reports
        data.savedReports.forEach(report => {
          queryClient.setQueryData(['saved-reports', report.id], {
            savedReport: report
          })
        })
      }
    }
  )

  return query
}